var _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPraticalIconKlm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ic_safe"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M1.66683 0.666992C0.93045 0.666992 0.333496 1.26395 0.333496 2.00033V9.33366C0.333496 10.07 0.93045 10.667 1.66683 10.667V11.3337H3.00016V10.667H10.3335V11.3337H11.6668V10.667C12.4032 10.667 13.0002 10.07 13.0002 9.33366V8.66699H13.6668V7.33366H13.0002V4.00033H13.6668V2.66699H13.0002V2.00033C13.0002 1.26395 12.4032 0.666992 11.6668 0.666992H1.66683ZM1.66683 2.00033H11.6668V9.33366H1.66683V2.00033ZM8.00016 3.00033C6.5274 3.00033 5.3335 4.19423 5.3335 5.66699C5.3335 7.13975 6.5274 8.33366 8.00016 8.33366C9.47292 8.33366 10.6668 7.13975 10.6668 5.66699C10.6668 4.19423 9.47292 3.00033 8.00016 3.00033ZM2.3335 4.00033V7.33366H3.66683V4.00033H2.3335ZM8.00016 4.33366C8.73654 4.33366 9.3335 4.93061 9.3335 5.66699C9.3335 6.40337 8.73654 7.00033 8.00016 7.00033C7.26378 7.00033 6.66683 6.40337 6.66683 5.66699C6.66683 4.93061 7.26378 4.33366 8.00016 4.33366Z",
    fill: "#00A1DE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_421_3457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 12
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.66683 0.666992C0.93045 0.666992 0.333496 1.26395 0.333496 2.00033V9.33366C0.333496 10.07 0.93045 10.667 1.66683 10.667V11.3337H3.00016V10.667H10.3335V11.3337H11.6668V10.667C12.4032 10.667 13.0002 10.07 13.0002 9.33366V8.66699H13.6668V7.33366H13.0002V4.00033H13.6668V2.66699H13.0002V2.00033C13.0002 1.26395 12.4032 0.666992 11.6668 0.666992H1.66683ZM1.66683 2.00033H11.6668V9.33366H1.66683V2.00033ZM8.00016 3.00033C6.5274 3.00033 5.3335 4.19423 5.3335 5.66699C5.3335 7.13975 6.5274 8.33366 8.00016 8.33366C9.47292 8.33366 10.6668 7.13975 10.6668 5.66699C10.6668 4.19423 9.47292 3.00033 8.00016 3.00033ZM2.3335 4.00033V7.33366H3.66683V4.00033H2.3335ZM8.00016 4.33366C8.73654 4.33366 9.3335 4.93061 9.3335 5.66699C9.3335 6.40337 8.73654 7.00033 8.00016 7.00033C7.26378 7.00033 6.66683 6.40337 6.66683 5.66699C6.66683 4.93061 7.26378 4.33366 8.00016 4.33366Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_421_3457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x8E\xA8-Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Black",
    d: "M23.6668 -10.666H-9.6665V22.6673H23.6668V-10.666Z",
    fill: "#00A1DE"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPraticalIconKlm);
export default __webpack_public_path__ + "static/media/pratical-icon-klm.248f442e04c45a68915b21427f99dabc.svg";
export { ForwardRef as ReactComponent };